import { Button, FilterCommon, HistoryModal, ImportModal, Modal, Pagination, Table } from "@/components";
import {
  CREATE_TYPE,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  HISTORY_TYPE,
  LEAVE_CARRYOVER_SCREEN,
  PAGINATION_DEFAULT,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
  toFixedNumber,
} from "@/utils";
import { mapState } from "vuex";
import LeaveCarryoverModal from "./LeaveCarryoverModal/LeaveCarryoverModal.vue";
const columns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 60,
    align: "right",
  },
  {
    title: "Name",
    dataIndex: "fullName",
    key: "name",
  },
  {
    title: "Division",
    dataIndex: "division",
    key: "division",
    customCell() {
      return {
        style: {
          fontWeight: 700,
          color: "#4F656F",
        },
      };
    },
    width: 230,
  },
  {
    title: "Financial Year",
    dataIndex: "financialYear",
    key: "financialYear",
    width: 120,
  },
  {
    title: "Leave Hour(s)",
    dataIndex: "leaveHours",
    key: "leaveDay",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 120,
    align: "right",
  },
  {
    title: "Used",
    dataIndex: "usedHours",
    key: "used",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 100,
    align: "right",
  },
  {
    title: "Remaining",
    dataIndex: "remainHours",
    key: "remaining",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 100,
    align: "right",
  },
  {
    title: "Expired",
    dataIndex: "expiredHours",
    key: "expired",
    customRender(value) {
      return toFixedNumber(value, 2);
    },
    width: 100,
    align: "right",
  },
  {
    title: "Note",
    dataIndex: "description",
    key: "note",
    ellipsis: true,
    width: 250,
  },
  {
    title: "Date Applied",
    dataIndex: "applyDateFormat",
    key: "dateApplied",
    width: 140,
    align: "center",
  },
  {
    title: "Date Expired",
    dataIndex: "expireDateFormat",
    key: "dateExpired",
    width: 140,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 200,
    fixed: "right",
    align: "center",
  },
];

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

export default {
  name: "LeaveManagement",
  components: {
    FilterCommon,
    Button,
    Pagination,
    Modal,
    LeaveCarryoverModal,
    Table,
    ImportModal,
    HistoryModal,
  },

  data() {
    return {
      dataFilterDefault: {},
      loading: false,
      columns,
      visibleModal: false,
      visibleModalImport: false,
      visibleModalHistory: false,
      recordActive: {},
      filter: PAGINATION_DEFAULT,
      actions,
      type: null,
      loadingDownload: false,
      LEAVE_CARRYOVER_SCREEN,
      filterList: filtersJson[LEAVE_CARRYOVER_SCREEN],
    };
  },
  computed: {
    ...mapState({
      leaveCarryoverList: (state) => state.leaveCarryover.leaveCarryoverList,
      historyByLeaveCarryoverList: (state) => state.leaveCarryover.historyByLeaveCarryoverList,
      pages: (state) => state.leaveCarryover.pages,
      userInfo: (state) => state.user.userInfo,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  watch: {
    filter() {
      this.getLeaveCarryoverList(this.filter);
    },
  },
  created() {
    // Get time server
    this.$store.dispatch("application/getTimeServer");
  },
  mounted() {
    this.getLeaveCarryoverList();
  },
  methods: {
    async getLeaveCarryoverList() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("leaveCarryover/getLeaveCarryoverList", this.filter);
      } catch (error) {
        handleMessagesAPI(error.response.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleAddNew() {
      this.visibleModal = true;
      this.type = CREATE_TYPE;
    },
    handleFilter(filter) {
      const { applyFromDate, applyToDate, expireFromDate, expireToDate } = filter;
      !applyFromDate && delete this.filter?.applyFromDate;
      !applyToDate && delete this.filter?.applyToDate;
      !expireFromDate && delete this.filter?.expireFromDate;
      !expireToDate && delete this.filter?.expireToDate;
      this.filter = { ...this.filter, ...filter, page: 1 };
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    onCancel() {
      this.visibleModal = false;
      this.visibleModalImport = false;
      this.visibleModalHistory = false;
      this.type = null;
      this.recordActive = {};
    },
    async onAction({ type, data }) {
      this.type = type;
      this.recordActive = data;
      switch (type) {
        case HISTORY_TYPE: {
          try {
            await this.$store.dispatch("leaveCarryover/historyLeaveCarryover", { id: data.id });
            this.visibleModalHistory = true;
          } catch (error) {
            handleMessagesAPI(error.response.data);
          }
          break;
        }
        default: {
          this.visibleModal = true;
        }
      }
    },
    handleImport() {
      this.visibleModalImport = true;
    },
    async downloadTemplate() {
      this.loadingDownload = true;
      try {
        const res = await this.$store.dispatch("leaveCarryover/downloadTemplate");
        handleMessagesAPI(res?.headers);
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        setTimeout(() => {
          this.loadingDownload = false;
        }, 500);
      }
    },
    async onImport(values, onSuccess) {
      try {
        this.loading = true;
        const res = await this.$store.dispatch("leaveCarryover/importLeaveCarryover", values);
        handleMessagesAPI(res?.headers);
        const { code } = res?.headers;
        if (code == 200) {
          this.getLeaveCarryoverList();
          onSuccess();
          this.onCancel();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.loading = false;
      }
    },
  },
};
